<div class="talent-page-wrapper share-wrapper">
    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <app-loader></app-loader>
    </div>

    <!-- Brand Header -->
    <header class="talent-header">
        <div class="logo-section">
            <ng-container *ngIf="logoUrl; else defaultLogo">
                <img [src]="logoUrl" alt="Company Logo" style="max-height: 40px; max-width: 150px; object-fit: contain; margin-right: 10px;">
            </ng-container>
            <ng-template #defaultLogo>
                <div class="logo-icon"><i class="bi bi-cpu-fill"></i></div>
            </ng-template>
            <div class="logo-text">
                <h6>{{ organizationName || 'AI Interview Platform' }}</h6>
                <p>SYSTEM SETUP</p>
            </div>
        </div>
        <div class="secure-badge">
            <span class="dot"></span>
            Secure AI session
        </div>
    </header>

    <div class="screen-page-container">
        <div class="card-container">
            <div class="icon-wrapper">
                <i class="bi bi-display"></i>
            </div>
            <h2>Share Your Entire Screen</h2>
            <p class="subtitle">You must share your <strong>entire screen</strong> before the interview begins.
                Tab or window sharing is not allowed.</p>

            <!-- ── Pre-share checklist ──────────────────────────────────── -->
            <div class="checklist-box" *ngIf="!streamActive">
                <h6><i class="bi bi-clipboard-check"></i> Before you continue</h6>
                <p class="checklist-intro">Please complete this step or your interview cannot start:</p>

                <label class="checklist-item" [class.checked]="closedOtherApps">
                    <input type="checkbox" [(ngModel)]="closedOtherApps">
                    <span class="checkmark"></span>
                    <span class="check-text">
                        I have <strong>closed or minimized</strong> all other applications and
                        notifications that could appear on screen
                    </span>
                </label>

                <div class="checklist-warning" *ngIf="!checklistComplete">
                    <i class="bi bi-shield-exclamation"></i>
                    Please check the box above to proceed.
                </div>
            </div>

            <!-- ── How to share (only before sharing) ─────────────────── -->
            <div class="how-to-box" *ngIf="!streamActive">
                <h6>How to share</h6>
                <ul>
                    <li><span class="circle">1</span> Click the "Share Screen" button below.</li>
                    <li><span class="circle">2</span> Select <strong>"Entire Screen"</strong> in the prompt.</li>
                    <li><span class="circle">3</span> Allow browser permissions to continue.</li>
                </ul>
            </div>

            <!-- ── Normal status box (not scanning, no meeting) ──────── -->
            <div class="status-box"
                 [ngClass]="streamActive ? 'active' : 'inactive'">
                <i class="bi" [ngClass]="streamActive ? 'bi-check-circle-fill' : 'bi-exclamation-triangle'"></i>
                {{ errorMessage }}
            </div>

            <!-- ── Action buttons ──────────────────────────────────── -->
            <div class="actions-row">
                <button class="btn-share w-100" (click)="shareScreen()"
                        [disabled]="streamActive || !checklistComplete">
                    <i class="bi bi-display"></i> Share Screen
                </button>
            </div>
        </div>
    </div>
</div>
